import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';

const { name } = STORE.modules.mixingModule;

export default class MixingModule extends Model {
  static entity = `${ name }`;

  static primaryKey = 'trial_id';

  static fields() {
    return {
      trial_id: this.attr(null),
      premixes: this.attr({}),
      mixes: this.attr({}),
      total: this.attr({}),
      custom_ingredients: this.attr({}),
    };
  }

  static methodConf = {
    http: {
      url: '/modules/mixing',
    },
    methods: {
      $get: {
        name: 'get',
        http: {
          url: '/:id/object',
          method: 'get',
        },
      },
      $create: {
        name: 'create',
        http: {
          url: '/:id/object',
          method: 'put',
        },
      },
    },
  };
}
